export const PERMISSION = {
  CARD_COLLECTION: "read:card_collection",
  PATIENT_AR: "read:patient_ar",
  FINANCIAL_AGGREGATE: "read:financial_aggregate",
} as const;

export type Permission = (typeof PERMISSION)[keyof typeof PERMISSION];
